import PageTitle from 'apps/home/components/PageTitle';
import MetaDecorator from 'apps/home/components/MetaDecorator';
import apiCall from 'apps/investment/apiCalls/stock-balance-histories';
import listByUserApiCall from 'apps/investment/apiCalls/stock-balance-histories/list-by-user';
import stockAccountApiCall from 'apps/investment/apiCalls/stock-accounts';
import { DataTable } from 'common/data-table';
import DataTablePagination from 'common/data-table-pagination';
import { DynamicFilterForm } from 'common/dynamic-filter-form';
import { DetailPage } from 'common/ui/admin-CRUD/page';
import ErrorMessage from 'common/ui/ErrorMessage';
import LoadingSpinner from 'common/ui/LoadingSpinner';
import { useFetchApiGet, useFetchApiList } from 'hooks/api';
import { useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { columnsGenerator, filterConfig } from './config';
import ItemDetail from './detail';

const FilterForm = () => (
  <DynamicFilterForm fields={filterConfig} showSearchField={false} />
);

// Balance history is only listed per stock account, never across all users.
export const StockAccountBalanceHistoryPage = () => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const query = Object.fromEntries(searchParams.entries());

  const {
    data: stockAccount,
    load: loadStockAccount,
    isLoading: isLoadingStockAccount,
    error: stockAccountError,
  } = useFetchApiGet(stockAccountApiCall.detail, { resourceName: 'data' });

  const {
    data,
    paging,
    isLoading,
    load,
    error,
  } = useFetchApiList(listByUserApiCall, { resourceName: 'data' });

  useEffect(() => {
    if (id) loadStockAccount({ id });
  }, [id]);

  const userId = (stockAccount as any)?.user_id;
  useEffect(() => {
    if (userId) load({ ...query, user_id: userId });
  }, [userId, JSON.stringify(query)]);

  if (isLoadingStockAccount || (!stockAccount && !stockAccountError)) {
    return <LoadingSpinner />;
  }
  if (stockAccountError) {
    return <ErrorMessage {...(stockAccountError as any)} />;
  }

  const accountLabel =
    (stockAccount as any)?.account_number || (stockAccount as any)?.id;

  return (
    <>
      <MetaDecorator title="Balance History" />
      <PageTitle
        title={`Balance History - ${accountLabel}`}
        backUrl={`/investment/stock-accounts/${id}`}
      />
      {error ? (
        <ErrorMessage errors={error} />
      ) : isLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          <DataTable
            columns={columnsGenerator().filter(
              column => column.accessorKey !== 'user'
            )}
            FilterForm={FilterForm}
            data={data || []}
          />
          {paging && <DataTablePagination paging={paging} />}
        </>
      )}
    </>
  );
};

export const InvestmentBalanceHistoriesDetailPage = () => (
  <DetailPage
    title="Request"
    apiCall={apiCall}
    listUrl={`/investment/stock-accounts`}
    ItemDetail={ItemDetail}
    options={{ editEnabled: false }}
  />
);
